import fs from 'node:fs'
import path from 'node:path'
import type { ProjectPackageJson } from '@cli-types/next-adapter/utils.js'

export function readProjectPackageJson(cwd: string): ProjectPackageJson | null {
  const pkgPath = path.join(cwd, 'package.json')
  if (!fs.existsSync(pkgPath)) return null

  try {
    return JSON.parse(fs.readFileSync(pkgPath, 'utf-8')) as ProjectPackageJson
  } catch {
    return null
  }
}
